import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { styled } from '@mui/material/styles';
import {
  Box,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  Stack,
  Select,
  MenuItem
} from '@mui/material';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

ListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  onDelete: PropTypes.func
};

export default function ListToolbar({
  stocks_type,
  device_code,
  numSelected,
  filterName,
  onFilterName,
  onDelete,
  onChangeType,
  onChangeExp,
  onChangeRep,
  onChangeDeviceCode
}) {
  const { SystemLib } = window;
  const [type, setType] = useState(stocks_type);
  const types = [
    { code: '4mar', name: 'marche' },
    { code: 'sdhy', name: 'はなまる' },
    { code: 'ymis', name: '味仙' },
    { code: '4mar sdhy ymis', name: 'その他' }
  ];
  const [exp_status, setExpStatus] = useState(-1);
  const exp_statuses = ['回収必須', '回収注意', '適正', '指示済', '未稼働'];
  const [rep_status, setRepStatus] = useState(-1);
  const rep_statuses = ['補充検討', '要補充', '適正', '指示済', '未稼働'];
  const [deviceCode, setDeviceCode] = useState(device_code);
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    getDevices();
  }, []);

  const getDevices = async () => {
    const { data } = await SystemLib.api('stock/devices', {}, 'post');
    if (data.result) {
      setDevices(data.data);
    }
  };

  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter'
        })
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} 件 選択中
        </Typography>
      ) : (
        <Stack direction="row" spacing={2}>
          <Select
            labelId="select_label_type"
            id="select_type"
            value={type}
            onChange={(e) => {
              setType(e.target.value);
              onChangeType(e.target.value);
            }}
          >
            <MenuItem value={-1}>種別 選択...</MenuItem>
            {types.map((v) => (
              <MenuItem key={v.code} value={v.code}>
                {v.name}
              </MenuItem>
            ))}
          </Select>
          <Select
            labelId="select_label_exp"
            id="select_exp"
            value={exp_status}
            onChange={(e) => {
              setExpStatus(e.target.value);
              onChangeExp(e.target.value);
            }}
          >
            <MenuItem value={-1}>回収状況 選択...</MenuItem>
            {exp_statuses.map((v) => (
              <MenuItem key={v} value={v}>
                {v}
              </MenuItem>
            ))}
          </Select>
          <Select
            labelId="select_label_rep"
            id="select_rep"
            value={rep_status}
            onChange={(e) => {
              setRepStatus(e.target.value);
              onChangeRep(e.target.value);
            }}
          >
            <MenuItem value={-1}>在荷状況 選択...</MenuItem>
            {rep_statuses.map((v) => (
              <MenuItem key={v} value={v}>
                {v}
              </MenuItem>
            ))}
          </Select>
          <Select
            labelId="select_label_device"
            id="select_device"
            value={deviceCode}
            onChange={(e) => {
              setDeviceCode(e.target.value);
              onChangeDeviceCode(e.target.value);
            }}
          >
            <MenuItem value={-1}>デバイス選択...</MenuItem>
            {devices.map((v) => (
              <MenuItem key={v.code} value={v.code}>
                {v.name}
              </MenuItem>
            ))}
          </Select>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="検索..."
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
        </Stack>
      )}

      {numSelected > 0 ? (
        <Tooltip title="削除">
          <IconButton onClick={onDelete}>
            <Icon icon={trash2Fill} />
          </IconButton>
        </Tooltip>
      ) : null}
    </RootStyle>
  );
}
